export default "__VITE_ASSET__RSHMOeYT__"